import React, { useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { isMobileOnly } from 'react-device-detect';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import './FilterButtons.scss';
import { RootState } from '../../../configs/store';
import SportsBettingContext from '../Context/SportsBetting.context';
import Button from '../../Button/Button';
import useIsMobile from 'src/hooks/useIsMobile';

function FilterButtons() {
  const [collapsed, setCollapsed] = useState(true);
  const { maxFilterButtons, setSelectedSport } = useContext(SportsBettingContext);
  const mobile = useIsMobile();
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // REDUX
  const { eventsTop, filterSports: { top } } = useSelector((state: RootState) => state.events);

  let showMore = true;

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const getEventsByTop = (topFilter) => {
    setSelectedSport(null);

    if (top === topFilter) {
      dispatch.events.clearSelectedTop(null);
      dispatch.filters.setFilterResults([]);
      dispatch.events.getSportEvents();
    } else {
      dispatch.events.getEventsByTop(topFilter);
    }
  };

  const showMoreButton = (index) => {
    return (
      <Button
        key={ `maxFilterButtons${ index }` }
        className={
          classNames({
            'sports-filter-buttons__filter-button': true,
            'sports-filter-buttons__filter-button--show-more': collapsed,
            'btn--outlined': true,
            'sports-filter-buttons__filter-button--show-less': !collapsed
          })
        }
        onClick={ toggleCollapse }
        text={ t(`filterButtons.${ collapsed ? 'showMore' : 'showLess' }`) + ` (${ eventsTop.length - index })` }
      />
    );
  };

  const handleEventTop = filter => e => {
    e.preventDefault();

    if (mobile) {
      history.push(`/sports-betting/top/${ filter.topFilter }${ location.search }`);
    } else {
      getEventsByTop(filter.topFilter);
    }
  };

  const filterButton = (index, filter) => {
    return (
      <Button
        key={ index }
        className={
          classNames({
            'sports-filter-buttons__filter-button': true,
            'btn--outlined': true,
            'sports-filter-buttons__filter-button--selected': filter.topFilter === top
          })
        }
        onClick={ handleEventTop(filter) }
        type = "button"
      >
        <span>{ filter.name } &nbsp;({ filter.events })</span>
      </Button>
    );
  };

  return (
    <div className="sports-filter-buttons">
      <div className="sports-filter-buttons__filter-button-container" style={ { height: !isMobileOnly && collapsed ? '40px' : 'auto' } }>
        {
          _.map(eventsTop, (filter, index: number) => {
            const button = [];

            if (
              !(mobile) &&
              maxFilterButtons < eventsTop.length &&
              maxFilterButtons > 1 &&
              index + 1 === maxFilterButtons
            ) {
              button.push(showMoreButton(index));

              showMore = false;
            }

            if (showMore || !collapsed) {
              button.push(filterButton(index, filter));
            }

            return button;
          })
        }
      </div>
    </div>
  );
}

export default FilterButtons;
